import React from 'react';
import CollegeInfoForm from 'modules/student/profile/profileForms/College';

const CollegeInfo = ({ student, editable, profile: { college_info } }) => {
  return <CollegeInfoForm user={student} editable={editable} />;
};

export default CollegeInfo;
